import classNames from 'clsx'
import type { VFC } from 'react'

interface AttributePickerValueProps {
  pickerValue?: string
  variantAttributeType: string
  packageSizeAttribute: boolean
  id?: string
  isMasterPage?: boolean
  isPersonal?: boolean
  isSingleAttributeProduct?: boolean
  displayExcludedValues?: boolean
}

const AttributePickerValue: VFC<AttributePickerValueProps> = ({
  pickerValue,
  variantAttributeType,
  packageSizeAttribute,
  id,
  isSingleAttributeProduct = false,
  displayExcludedValues = false,
}) => {
  const isColorVariantType = variantAttributeType.toLowerCase() === 'color'
  const hasColor = isColorVariantType && pickerValue?.includes('#')

  const [colorName, colorHexNumber] = pickerValue?.includes('#')
    ? pickerValue.split('#')
    : [pickerValue, '']

  const pickerValueStyles = classNames({
    'a-singleVariant--pickerValueFont--font u-no-margin--bottom':
      isSingleAttributeProduct,
    'colorPicker': hasColor,
    'l-flex': hasColor || !packageSizeAttribute,
    'l-flex l-flex--center': packageSizeAttribute && isSingleAttributeProduct,
  })

  const colorPickerColorStyles = classNames({
    'colorPickerColor': hasColor,
    'whiteColorPickerColor':
      colorHexNumber?.toLowerCase() === 'fff' ||
      colorHexNumber?.toLowerCase() === 'ffffff',
  })

  const tilePickerValueClasses = classNames('u-text-truncate', {
    'a-h4 u-font-weight--bold': isColorVariantType && isSingleAttributeProduct,
    'u-font-weight--bold o-ExcludedAttributeValue__tile--excluded':
      displayExcludedValues,
    'o-buttonValueDisplay-margin': hasColor,
    'u-no-margin o-buttonValueDisplay-min-height':
      !hasColor && isSingleAttributeProduct,
  })

  return (
    <span className={pickerValueStyles}>
      {isColorVariantType ? (
        <>
          <span
            style={{ backgroundColor: `#${colorHexNumber}` }}
            className={colorPickerColorStyles}
          ></span>
          <span id={id} className={tilePickerValueClasses}>
            {colorName}
          </span>
        </>
      ) : (
        <span className={tilePickerValueClasses}>{pickerValue}</span>
      )}
    </span>
  )
}

export default AttributePickerValue
